<template>
  <component :is="currentUser.is_resto_admin ? 'resto-admin-layout' : 'main-layout'">
    <div class="mt-16 bg-grey-lighter flex justify-center items-center">
      <div class="bg-white border rounded py-8 px-8 w-full md:w-2/3 lg:w-1/3 login-form">
        <div class="flex justify-start">
          <div class="w-full">
            <Logo />
            <h2 class="login-form-title">Reset Password</h2>
          </div>
        </div>
        <div class="flex">
          <div class="w-full">
            <pt-form-group>
              <div
                slot="form-group-label"
                class="mb-2"
              >New Password <span class="font-bold text-red">*</span></div>
              <pt-form-input
                id="pass"
                v-model="newPassword"
                type="password"
                placeholder="Enter New Password"
              />
            </pt-form-group>
            <pt-form-group>
              <div
                slot="form-group-label"
                class="mb-2"
              >Old Password <span class="font-bold text-red">*</span></div>
              <pt-form-input
                id="old-pass"
                v-model="oldPassword"
                type="password"
                placeholder="Enter Old Password"
                @keyup.enter.native="updatePassword"
              />
            </pt-form-group>
          </div>
        </div>

        <!-- <router-link
          to="/reset-password"
          class="mb-4 no-underline text-primary font-bold hover:text-primary-dark space-letters"
        >Forgot your password?</router-link> -->
        <div class="flex lg:flex-row sm:flex-col justify-start">
          <div class="">
            <pt-button
              :disabled="inProgress"
              :class="{
                'opacity-50 cursor-not-allowed': inProgress
              }"
              class="login-button"
              variant="primary"
              @action="updatePassword"
            >
              {{ inProgress ? 'Updating...' : 'Update' }}
              <!-- <pt-loader
                v-show="tryingToLogIn"
                icon-class="fa-spinner" /> -->
            </pt-button>
          </div>
          <!-- <div class="flex justify-center items-center sm:mt-2 lg:mt-0 sm:w-full lg:w-2/3">
            <router-link
              class="text-grey-dark font-bold no-underline hover:text-grey-darker space-letters"
              to="/signup"
            >New partner? Sign Up</router-link>
          </div> -->
        </div>
      </div>
    </div>
  </component>
</template>

<script>
import { PtFormGroup, PtFormInput } from '@pathao/ui-components/esm/FormComponents';
import Logo from '@components/navigation/Logo';
import { UPDATE_PASS } from '@src/config/apiEndpoints';
import apiRequest from '@src/utils/apiRequest';
import MainLayout from '@layouts/main';
import RestoAdminLayout from '@layouts/resto-admin';
import { mapActions, mapGetters } from 'vuex';

export default {
  page: {
    title: 'Reset password',
    // meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    MainLayout,
    RestoAdminLayout,
    PtFormInput,
    PtFormGroup,
    Logo,
  },
  data() {
    return {
      newPassword: '',
      oldPassword: '',
      inProgress: false,
    };
  },
  computed: {
    ...mapGetters({
      currentUser: 'auth/user',
    }),
  },
  methods: {
    updatePassword() {
      if (!this.newPassword.trim()) {
        this.$notification.error('Password is required');
        return;
      }
      if (!this.oldPassword.trim()) {
        this.$notification.error('Old password is required');
        return;
      }

      if (this.oldPassword.trim() === this.newPassword.trim()) {
        this.$notification.error('New and old password can\'t be same.');
        return;
      }

      let payload = {
        url: UPDATE_PASS,
        method: 'POST',
        data: {
          password: this.newPassword,
          old_password: this.oldPassword,
        },
      };
      this.inProgress = true;
      apiRequest(payload)
        .then((response) => {
          this.inProgress = false;
          if (response.data.success) {
            this.newPassword = '';
            this.$notification.success(response.data.message);
            this.$sendEvent('RS_ResetPassword');
            this.logOut();
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          }
        }).catch((err) => {
          this.inProgress = false;
          let errorMessage = (err.response && err.response.data)
            ? err.response.data.message : 'May be something is wrong. Server is down or not responding.';
          this.$notification.error(errorMessage);
        });
    },
    ...mapActions({
      logOut: 'auth/logOut',
    }),
  },
};
</script>

<style>
  .login-form {
    border: 1px solid #DDDDDD;
    box-shadow: 0 2px 6px 0 rgba(0,0,0,0.24);
    border-radius: 2px;
  }
  .login-form-label {
    font-size: 16px;
    font-weight: 600;
    color: #545454;
    text-align: left;
    line-height: 24px;
  }
  .login-form-title {
    font-size: 24px;
    font-weight: normal;
    padding: 25px 0px;
    color: #000000;
    line-height: 32px;
  }
  .pt-input-container #username, #password {
    background: #FFFFFF;
    /*border: 0.5px solid #8E8E93;*/
    border-radius: 2px;
    line-height: 24px;
    margin-bottom: 20px;
  }
  .login-button {
    height: unset;
    padding-top: 10px;
    padding-bottom: 10px;
  }
</style>
